<template>
  <div>
    <el-row class="mb-20">
      <el-col :span="24">
        <el-table :data="performances" border stripe class="item-table desktop-table">
          <el-table-column type="expand" width="60">
            <template slot-scope="props">
              <div class="expanded-details">
                <p class="detail-item"><strong>Round Type:</strong> {{ props.row.round?.type || 'N/A' }}</p>
                <p class="detail-item"><strong>Round Number:</strong> {{ props.row.round?.number || 'N/A' }}</p>
                <p class="detail-item"><strong>Date & Time:</strong> {{ dateFormatter(props.row.dateTime) }}</p>
                <p class="detail-item"><strong>Status:</strong> {{ statusFormatter(props.row.status) }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="competition.name" label="Competition" min-width="200" >
            <template slot-scope="scope">
              <span class="break-word">
                {{ scope.row.competition.name }}
              </span>
            </template>

          </el-table-column>

          <el-table-column  label="Match" min-width="400">
            <template slot-scope="scope">
              <div class="match-team">
                <div class="d-flex justify-content-between">
                  <el-tooltip :content="scope.row.teamPlayed === get(scope.row, 'homeTeam._id')? `${get(scope.row, 'homeTeam.name', 'N/A')} - Your Team`: `${get(scope.row, 'homeTeam.name', 'N/A')} - Home Team`" effect="light" placement="top-end">
                    <el-tag class="team-tag"  :effect="teamWin(scope.row, 'home')? 'dark': 'plain'">
                      {{ get(scope.row, 'homeTeam.name', 'N/A') }}
                    </el-tag>
                  </el-tooltip>
                  <el-tag  :type="teamWin(scope.row, 'home')? 'success': 'info'" effect=dark>
                      {{ scope.row.scores.homeTeam }}
                  </el-tag>
                </div>
                <div class="text-center">VS</div>
                <div class="d-flex justify-content-between">
                  <el-tag  effect=dark :type="teamWin(scope.row, 'away')? 'success': 'info'" >
                      {{ scope.row.scores.awayTeam }}
                  </el-tag>
                  <el-tooltip :content="scope.row.teamPlayed === scope.row.awayTeam._id? `${get(scope.row, 'awayTeam.name', 'N/A')} - Your Team`: `${get(scope.row, 'awayTeam.name', 'N/A')} - Away Team`" effect="light" placement="top-end">
                    <el-tag class="team-tag" :effect="teamWin(scope.row, 'away')? 'dark': 'plain'">
                      {{ get(scope.row, 'awayTeam.name', 'N/A') }}
                    </el-tag>
                  </el-tooltip>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="playerOfTheMatch" label="Award" width="150">
            <template slot-scope="scope">
              <span class="break-word">
                {{ getPlayerOfTheMatch(scope.row)}}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="scoringEvents" label="Performance" :formatter="performanceFormatter"  width="150">
            <template slot-scope="scope">
              <span class="break-word">
              {{ performanceFormatter(scope.row.scoringEvents)}}
              </span>
            </template>
          </el-table-column>
        </el-table>

        <el-table
          :data="performances"
          border
          stripe
          class="item-table mobile-table"
          lazy
        >
          <el-table-column type="expand" width="60">
            <template slot-scope="props">
              <div class="expanded-details">
                <p class="detail-item"><strong>Round Type:</strong> {{ props.row.round?.type || 'N/A' }}</p>
                <p class="detail-item"><strong>Round Number:</strong> {{ props.row.round?.number || 'N/A' }}</p>
                <p class="detail-item"><strong>Date & Time:</strong> {{ dateFormatter(props.row.dateTime) }}</p>
                <p class="detail-item"><strong>Status:</strong> {{ statusFormatter(props.row.status) }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="competition.name" label="Competition" min-width="180" >
            <template slot-scope="scope">
              <span class="break-word">
                {{ scope.row.competition.name }}
              </span>
            </template>

          </el-table-column>
          <el-table-column  label="Match" min-width="400">
            <template slot-scope="scope">
              <div class="match-team">
                <div class="d-flex justify-content-between">
                  <el-tooltip :content="scope.row.teamPlayed === get(scope.row, 'homeTeam._id')? `${get(scope.row, 'homeTeam.name', 'N/A')} - Your Team`: `${get(scope.row, 'homeTeam.name', 'N/A')} - Home Team`" effect="light" placement="top-end">
                    <el-tag class="team-tag"  :effect="teamWin(scope.row, 'home')? 'dark': 'plain'">
                      {{ get(scope.row, 'homeTeam.name', 'N/A') }}
                    </el-tag>
                  </el-tooltip>
                  <el-tag  :type="teamWin(scope.row, 'home')? 'success': 'info'" effect=dark>
                      {{ get(scope,'row.scores.homeTeam') }}
                  </el-tag>
                </div>
                <div class="text-center">VS</div>
                <div class="d-flex justify-content-between">
                  <el-tag  effect=dark :type="teamWin(scope.row, 'away')? 'success': 'info'" >
                      {{ get(scope, 'row.scores.awayTeam' )}}
                  </el-tag>
                  <el-tooltip :content="scope.row.teamPlayed === scope.row.awayTeam._id? `${get(scope.row, 'awayTeam.name', 'N/A')} - Your Team`: `${get(scope.row, 'awayTeam.name', 'N/A')} - Away Team`" effect="light" placement="top-end">
                    <el-tag class="team-tag" :effect="teamWin(scope.row, 'away')? 'dark': 'plain'">
                      {{ get(scope.row, 'awayTeam.name', 'N/A') }}
                    </el-tag>
                  </el-tooltip>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="playerOfTheMatch" label="Award" width="180">
            <template slot-scope="scope">
              <span class="break-word">
              {{ getPlayerOfTheMatch(scope.row)}}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="scoringEvents" label="Performance" :formatter="performanceFormatter"  width="150">
            <template slot-scope="scope">
              <span class="break-word">
              {{ performanceFormatter(scope.row.scoringEvents)}}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import _, { capitalize } from 'lodash';
import { matchStatus } from '@/utils/constants';

export default {
  props: ['member'],
  data() {
    return {
      capitalize,
      performances: [{
        _id: '',
        competition: {
          name: '',
        },
        homeTeam: {
          name: '',
          _id: null
        },
        awayTeam: {
          name: '',
          _id: null
        },
        scores: {
          homeTeam: 0,
          awayTeam: 0
        },
      }],
      get: _.get
    };
  },
  mounted() {
    if (this.member._id) {
      this.$store.commit('loading', { loading: true, text: 'Loading...' });
      this.$http.get(`/assemble/api/v1/account/portal/members/${this.member._id}/performances`)
        .then((res) => {
          this.performances = res.data.data;
          this.$store.commit('loading', false);
        })
        .catch((error) => {
          this.$store.commit('loading', false);
          this.$message.error(error.response.data.message);
        });
    }
  },
  methods: {
    teamWin(row, type) {
      if (type === 'home') {
        return row.scores.homeTeam > row.scores.awayTeam;
      }
      return row.scores.homeTeam < row.scores.awayTeam;
    },
    statusFormatter(value) {
      if (!value) return '';
      return _.find(matchStatus, { value }).label;
    },
    dateFormatter(v) {
      return v ? this.moment(v).format('YYYY-MM-DD HH:mm') : '';
    },
    performanceFormatter(value) {
      if (value && value.length) {
        const byScoringType = value
          .filter((v) => v.meta && v.meta.player && v.meta.player._id === this.member._id)
          .map((v) => v.name)
          .reduce((acc, c) => ({ ...acc, [c]: acc[c] ? acc[c] + 1 : 1 }), {});
        // check if has scoring type return none if empty
        if (Object.keys(byScoringType).length) {
          return Object.keys(byScoringType).map((k) => (`${k}: ${byScoringType[k]}`)).join(', ');
        }
        return 'None';
      }
      return 'None';
    },
    getPlayerOfTheMatch(row) {
      if (row.playerOfTheMatch) {
        const foundAward = row.playerOfTheMatch.find((p) => p._id === this.member._id);
        if (foundAward) return foundAward.name;
      }
      return 'None';
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .item-table {
  border: 1px solid rgba(45, 58, 69, 0.1);

  &.mobile-table {
    display: none;
  }

  @media only screen and (max-width: $sm) {
    &.mobile-table {
      display: block !important;
    }
    &.desktop-table {
      display: none !important;
    }
  }

  th {
    background: #f6f8fa !important;
    padding-left: 1em;
    padding-right: 1em;
    text-align: left;
    height: 48px;
  }

  td {
    background-color: white !important;
    padding: 14px 8px;
    text-align: center;
  }
}

/* Expanded row styling from RegoHistory */
.expanded-details {
  padding: 20px;
  background-color: #FAFBFC;
  border-radius: 4px;
  margin: 0 20px;
}

.detail-item {
  margin-bottom: 8px;
  line-height: 1.5;
}

.detail-item strong {
  min-width: 120px;
  display: inline-block;
  font-weight: 500;
  color: #606266;
}

::v-deep .el-table__expanded-cell {
  padding: 15px 20px !important;
  background-color: #FAFBFC;
}

::v-deep .el-table__expand-icon {
  transition: transform 0.2s ease;
  margin-right: 5px;

  &.el-table__expand-icon--expanded {
    transform: rotate(90deg);
  }

  .el-icon {
    font-weight: bold;
    font-size: 14px;
    color: #409EFF;
  }
}

/* Clean table styling from RegoHistory */
::v-deep .el-table {
  border: 1px solid #EBEEF5 !important;
  border-radius: 4px !important;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03) !important;
}

::v-deep .el-table th {
  background-color: #F5F7FA !important;
  font-weight: 500 !important;
  color: #606266 !important;
  border-bottom: 1px solid #EBEEF5 !important;
  padding: 10px 0 !important;
}

::v-deep .el-table td {
  border-bottom: 1px solid #EBEEF5 !important;
  padding: 14px 8px !important;
}

::v-deep .el-table td, ::v-deep .el-table th {
  border-right: 1px solid #EBEEF5 !important;
}

::v-deep .el-table td:last-child, ::v-deep .el-table th:last-child {
  border-right: none !important;
}

::v-deep .el-table tr:hover > td {
  background-color: #F5F7FA !important;
}

::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #FAFBFC;
}

.match-team{
  width: 100%;
  display: grid;
  grid-template-columns: 4fr 40px 4fr;
  justify-content: center;
  .team-tag{
    width: 110px; /* adjust based on your needs */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
